export const INSIGHT_LABELS: Record<string, string> = {
  rhythm: 'Ritmo',
  diagnostic: 'Diagnóstico',
  form: 'Morfologia'
}

export const INSIGHT_COLORS: Record<string, 'primary' | 'success' | 'info'> = {
  rhythm: 'primary',
  diagnostic: 'success',
  form: 'info'
}

export const SBC_PROTOCOL_URL = 'https://www.portal.cardiol.br/diretrizes'
